export default __webpack_public_path__ + "static/media/desk_glowboo.88e9a2bc.webp";